import React from 'react'
import PubSub from 'pubsub-js'
import { without } from 'lodash/array'
import { Button } from 'semantic-ui-react'

import ActionModal from './ActionBar/ActionModal'

export class ActionBar extends React.PureComponent {
  state = {
    items: [],
    modalOpen: false,
  }

  componentWillMount () {
    this.subscriptions = PubSub.subscribe('ITEMS', this.onItemsAction.bind(this))
  }

  componentWillUnmount () {
    PubSub.unsubscribe(this.subscription)
  }

  onItemsAction (msg, data) {
    switch (msg) {
      case 'ITEMS.SHOW_MODAL':
        return this.setState({
          ...this.state,
          modalOpen: true,
        })

      case 'ITEMS.SELECT.add':
        return this.setState({
          ...this.state,
          items: [...this.state.items, data]
        })

      case 'ITEMS.SELECT.remove':
        return this.setState({
          ...this.state,
          items: without(this.state.items, data)
        })
    }
  }

  onButtonClick () {
    this.setState({
      ...this.state,
      modalOpen: true,
    })
  }

  closeModal () {
    this.setState({
      ...this.state,
      modalOpen: false,
    })
  }

  render () {
    if (this.state.items.length === 0) return null

    return (
      <div>
        <div className='ui action-bar'>
          <span className='ui action-bar-text'>Vybrané ({this.state.items.length}):</span>

          {this.state.items.length > 0 && (
            <Button secondary basic onClick={() => this.onButtonClick()} className='borderless'>
              <i className='plus icon' />
              Přidat do kolekce
            </Button>
          )}
        </div>

        <ActionModal
          modalOpen={this.state.modalOpen}
          items={this.state.items}
          close={() => this.closeModal()}
          {...this.props}
        />
      </div>
    )
  }
}

export default ActionBar



// WEBPACK FOOTER //
// ./app/javascript/components/ActionBar.js